define('OutSystems/ReactView/FeedbackMessage',["require", "exports", "tslib", "OutSystems/ClientRuntime/FeedbackMessageService", "OutSystems/ClientRuntime/WidgetNaming", "react", "react-dom", "./HtmlTags", "./Widget"], function (require, exports, tslib_1, FeedbackMessageService, WidgetNaming_1, React, ReactDOM, HtmlTags_1, Widget_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ReactFeedbackMessageService = (function () {
        function ReactFeedbackMessageService() {
            if (ReactFeedbackMessageService.instance) {
                throw new Error("Error: Instantiation failed, use FeedbackMessageService.getInstance() instead of new.");
            }
            ReactFeedbackMessageService.instance = this;
        }
        Object.defineProperty(ReactFeedbackMessageService, "Instance", {
            get: function () {
                return ReactFeedbackMessageService.instance;
            },
            enumerable: false,
            configurable: true
        });
        ReactFeedbackMessageService.prototype.showMessage = function (message, messageType, encodeHTML, extraCssClasses, closeOnClick, onClick) {
            if (encodeHTML === void 0) { encodeHTML = true; }
            if (closeOnClick === void 0) { closeOnClick = true; }
            var feedbackMessageContainer = document.getElementById(ReactFeedbackMessageService.FeedbackMessageId);
            if (!feedbackMessageContainer) {
                feedbackMessageContainer = document.createElement("div");
                feedbackMessageContainer.id = ReactFeedbackMessageService.FeedbackMessageId;
                feedbackMessageContainer.className = "feedback-message-wrapper";
                document.body.insertBefore(feedbackMessageContainer, document.body.firstChild);
            }
            else {
                ReactDOM.unmountComponentAtNode(feedbackMessageContainer);
            }
            var feedbackMessageProperties = {
                message: message,
                messageType: messageType,
                encodeHTML: encodeHTML,
                extraCssClasses: extraCssClasses,
                closeOnClick: closeOnClick,
                onClick: onClick,
                _idProps: { service: new WidgetNaming_1.WidgetIdService(null) },
            };
            ReactDOM.render(React.createElement(FeedbackMessageWidget, feedbackMessageProperties), feedbackMessageContainer);
        };
        ReactFeedbackMessageService.prototype.closeMessage = function () {
            var feedbackMessageContainer = document.getElementById(ReactFeedbackMessageService.FeedbackMessageId);
            if (feedbackMessageContainer) {
                ReactDOM.unmountComponentAtNode(feedbackMessageContainer);
                feedbackMessageContainer.remove();
            }
        };
        ReactFeedbackMessageService.FeedbackMessageId = "feedbackMessageContainer";
        ReactFeedbackMessageService.instance = new ReactFeedbackMessageService();
        return ReactFeedbackMessageService;
    }());
    var FeedbackMessageWidget = (function (_super) {
        tslib_1.__extends(FeedbackMessageWidget, _super);
        function FeedbackMessageWidget() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        FeedbackMessageWidget_1 = FeedbackMessageWidget;
        FeedbackMessageWidget.prototype.closeMessage = function (event) {
            if (this.feedbackMessageElement) {
                ReactFeedbackMessageService.Instance.closeMessage();
                event.preventDefault();
                this.feedbackMessageElement = null;
            }
        };
        FeedbackMessageWidget.prototype.componentDidMount = function () {
            this.feedbackMessageElement = this.getHTMLNode();
            if (this.feedbackMessageElement.getAttribute("class").indexOf(FeedbackMessageWidget_1.AUTOCLOSE_CLASS) !== -1) {
                this.feedbackMessageElement.addEventListener("animationend", this.closeMessage.bind(this), false);
            }
        };
        FeedbackMessageWidget.getMessageType = function (messageType) {
            switch (messageType) {
                case 0:
                    return "info";
                case 1:
                    return "success";
                case 2:
                    return "warning";
                case 3:
                    return "error";
                default:
                    throw new Error("Unknown MessageType: " + messageType);
            }
        };
        FeedbackMessageWidget.prototype.render = function () {
            var _this = this;
            var styleClasses = "feedback-message feedback-message-" + FeedbackMessageWidget_1.getMessageType(this.props.messageType);
            if (this.props.messageType === 0 ||
                this.props.messageType === 1) {
                styleClasses += FeedbackMessageWidget_1.AUTOCLOSE_CLASS;
            }
            if (this.props.extraCssClasses) {
                styleClasses += " " + this.props.extraCssClasses;
            }
            var attributes = {
                className: styleClasses,
            };
            if (this.props.onClick) {
                if (this.props.closeOnClick) {
                    attributes.onClick = function (evt) {
                        _this.props.onClick();
                        _this.closeMessage(evt);
                    };
                }
                else {
                    attributes.onClick = this.props.onClick;
                }
            }
            else if (this.props.closeOnClick) {
                attributes.onClick = this.closeMessage.bind(this);
            }
            this.fillWithBuiltinProperties(attributes);
            var messageTextAttributes = {
                className: "feedback-message-text",
            };
            if (this.props.encodeHTML) {
                messageTextAttributes.children = this.props.message;
            }
            else {
                messageTextAttributes.dangerouslySetInnerHTML = { __html: this.props.message };
            }
            return React.createElement(HtmlTags_1.HtmlTags.div, attributes, React.createElement(HtmlTags_1.HtmlTags.i), React.createElement(HtmlTags_1.HtmlTags.div, messageTextAttributes));
        };
        var FeedbackMessageWidget_1;
        FeedbackMessageWidget.AUTOCLOSE_CLASS = " feedback-message-autoclose";
        FeedbackMessageWidget = FeedbackMessageWidget_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], FeedbackMessageWidget);
        return FeedbackMessageWidget;
    }(Widget_1.Widget));
    FeedbackMessageService.registerFeedbackMessageService(ReactFeedbackMessageService.Instance);
});
//# sourceMappingURL=FeedbackMessage.js.map;
